﻿import 'select2';
import "../scss/personalizedPatch.scss";
import { AddressSearch, showInvalidAddressWarning, postAddressForValidation, getAddressesForValidation, updateAddresses, processHiddenErrors } from "../../../../Fundraising.UI.Shared/Modules/search/address/AddressSearch";
import { clearFields } from "../../../../Fundraising.UI.Shared/Modules/formTools/util";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.PersonalizedPatch = {};

    // Private Variables
    var patchTypeOrganization = "0";
    var patchTypeParticipant = "3";
    var patchTypeVolunteer = "2";
    var patchTypeUnit = "1";

    var patchGoalType_Units = "1";
    var patchGoalType_Dollars = "0";
    var isInIframe = (window.location !== window.parent.location) ? true : false;

    function setRecipientSelect() {
        var $patchTypeSelecter = $('.select-patch-type');
        var $recipientSelector = $('.recipient-select');
        var typeParam = $patchTypeSelecter.data('parameter-name');
        var recipientParam = $recipientSelector.data('parameter-name');
        var baseUrl = $patchTypeSelecter.data('url');


        $(".recipient-select").select2({
            dropdownAutoWidth: true,
            minimumInputLength: 1,
            width: '100%',
            placeholder: 'Search Recipient...',
            ajax: {
                url: baseUrl,
                dataType: 'json',
                delay: 500,
                data: function (params) {
                    var query = {};

                    query[typeParam] = function () {
                        return $patchTypeSelecter.val();
                    }

                    query[recipientParam] = params.term;

                    return query;
                },
                processResults: function (data) {
                    var select2Format = [];
                    Object.keys(data).forEach(function (key) {
                        var jsonData = {};
                        if (data[key].groupId === '') data[key].groupId = 'null';
                        jsonData['id'] = data[key].id;
                        jsonData['text'] = data[key].description;
                        select2Format.push(jsonData);
                    });
                    return {
                        results: select2Format
                    };
                }
            }
        }).select2('open').select2('close');
    }
    function setPatchTypeSelect() {
        $(document).on("change", ".select-patch-type", function () {
            var $recipientSelect = $('.recipient-select');
            $recipientSelect.val('').trigger('change');
            $(".field-grp.earners").addClass("hidden");
            $(".earner-address").removeClass('hidden');
            $(".earners").removeClass("hidden");
            $recipientSelect.next().find('.select2-selection__placeholder').html("Search " + $(this).find('option:selected').text() + "...");
        });
    }
    // Selector's used for Troop Leader and Service Unit patches
    function setPatchGoalTypeSelector() {
        $(document).on("change", ".patch-goal-type", function (e) {
            var selectedGoalType = $(this).val();

            var goalInput = $(this).parent().parent().next().find("input:text");
            var goalAppearance = $(this).parent().parent().next().find(".field-icon");
            if (selectedGoalType === patchGoalType_Units) {
                goalAppearance.removeClass("dollars ").addClass("units");
                if (parseInt(goalInput.val())) goalInput.val(Math.trunc(goalInput.val()));
            } else if (selectedGoalType === patchGoalType_Dollars) {
                goalAppearance.removeClass("units").addClass("dollars ");
            }
        });
    }
    function earnerSearch() {
        $(".select2-select").select2({
            width: 'auto'
        });
    }

    function disablePatchRow() {

        const togglePatchTriggers = document.querySelectorAll(".status input.switch-small");
        M2.Util.onSwitchesProcessed().then(() => {
            togglePatchTriggers.forEach(function (checkBx) {
                const switchId = checkBx.id;
                const switchObj = M2.Util.getSwitch(switchId);
                const $switch = $("#" + switchId);
                const patchRowRef = $switch.closest("tr");

                if (switchObj) {
                    switchObj.onChangeSuccess = function (state) {
                        if (state) {
                            patchRowRef.find(".criteria :input").attr("disabled", false);
                            patchRowRef.removeClass("disabled");
                        } else {
                            patchRowRef.find(".criteria :input").attr("disabled", true);
                            patchRowRef.addClass("disabled");
                        }
                    }
                }
            });
        });
        $(".personalized-patches .disabled .criteria :input").attr("disabled", true);
    }
    function earnPatchToggle() {
        const patchEarnedTriggers = document.querySelectorAll(".patch-earned input.switch-small");
        M2.Util.onSwitchesProcessed().then(() => {
            patchEarnedTriggers.forEach(function (checkBx) {


                const switchId = checkBx.id;
                const switchObj = M2.Util.getSwitch(switchId);
                const $switch = $("#" + switchId);

                if (switchObj) {
                    switchObj.onChangeSuccess = function (state) {
                        const earner_id = $switch.data("id");
                        const patch_type = $switch.data("personalizedpatchtype");
                        const patch_url = $switch.data("url");
                        const statusTarget = $switch.parent().prev();
                        const parentTR = $switch.closest("tr");
                        const currentState = $switch.prop('checked');
                        const token = $switch.closest("form").find("input[name='__RequestVerificationToken']").val();
                        let patch_earned;


                        if (state) {
                            patch_earned = "True";
                        } else {
                            patch_earned = "False";
                        }

                        const request = $.ajax({
                            url: patch_url,
                            dataType: "json",
                            method: "POST",
                            data: {
                                'id': earner_id,
                                'personalizedPatchType': patch_type,
                                'patchearned': patch_earned,
                                '__RequestVerificationToken': token
                            }
                        }).done(function (data) {
                            var statusHTML = "";
                            if (data.success) {
                                if (data.enumValue === "0") statusHTML = "<span class='icon attention'></span>";
                                statusHTML += data.earnerStatus;
                                statusTarget.html(statusHTML);
                                // 0 is Action Required
                                // 1 is Pending Production
                                // 2 In Production
                                // 3 Eligible
                                parentTR.removeClass("non-editable");
                                if (patch_earned !== "True" || data.enumValue === "2" || data.enumValue === "3") parentTR.addClass("non-editable");
                            } else {
                                alert(data.error);
                                if (currentState) {
                                    M2.Util.setSwitchery(switchObj, false, false);
                                }
                                else {
                                    M2.Util.setSwitchery(switchObj, true, false);
                                }
                            }
                        }).fail(function (jqXHR, textStatus, errorThrown) {
                            //console.log(errorThrown);
                        });
                    }
                }
            });
        });
    }
    function resizePatchiFrame() {
        M2.Modal.resizeParentIframe();
    }

    function setCancelDialogs() {
        $(document).on("click", ".close-patch-callout, #personalized-patch-overlay .close-patch-overlay", function (e) {
            e.preventDefault();
            var ref;
            if ($(this).hasClass('close-patch-callout')) ref = window;
            else ref = document.getElementById('iframe-personalized-patch-overlay').contentWindow.window;
            if (ref.$("#display-close-button-msg").val() === "True") {
                ref.$(".patch-callout-content").fadeOut("slow", function (e) {
                    ref.$(".close-patch-callout").addClass("hidden");
                    ref.$(".patch-callout-msg").show();
                    ref.M2.PersonalizedPatch.displayMessaging("cancel");
                });
                // Close the window if already entered Me2 and Address
            } else M2.Modal.close();
        });

        $(document).on("click", ".btn.go-back", function (e) {
            e.preventDefault();
            $(".patch-callout-msg").fadeOut("slow", function (e) {
                $(".close-patch-callout").removeClass("hidden");
                $(".patch-callout-content").show();
                if (isInIframe) resizePatchiFrame();
            });
        });

        $(document).on("click", ".patch-callout-msg.cancel .btn.confim", function (e) {
            e.preventDefault();
            $("#patch-callout-container").slideUp();
        });
    }

    function createVerticalText(txt) {
        var characters = txt.split("");
        var newText = "";

        $.each(characters, function (i, el) {
            if (el !== "." && el !== " ") newText += "<span>" + el + "</span>";
            if (el === " ") newText += "<span>&nbsp;</span>";
        });
        return newText;
    }

    function setPatchNamePosition() {

        // Set Selected Name/Position
        var nameOnPatch = $(".name-on-patch").find("option:selected").val();
        var patchType = $("#SelectedAvatarPersonalizedPatchId").find("option:selected").val();
        var patchDataSelector = "#data-patch-name-" + nameOnPatch + "-" + patchType;
        if (nameOnPatch === "NickName") $(patchDataSelector).data("patch-name", $("#NickName").val());

        const name = $(patchDataSelector).data("patch-name");
        const pos = $(patchDataSelector).data("patch-position");
        const axis = $(patchDataSelector).data("patch-axis");
        const fontFamily = $(patchDataSelector).data("patch-font-style");
        const fontColor = $(patchDataSelector).data("patch-color");
        const fontSize = $(patchDataSelector).data("patch-font-size");

        var position = pos.split(',');

        var width = $("#patch-preview-image").width();
        var height = $("#patch-preview-image").height();



        // One of these two points may be centered depending on axis
        var centerX = position[0];
        var centerY = position[1];

        var patchNameY;
        var patchNameX;

        var $patchName = $("#patch-name");
        $patchName.css("visibility", "hidden");

        // Set font family first to avoid mismatch measurements
        $patchName.css({
            fontFamily: fontFamily,
            fontSize: fontSize,
            color: "rgb(" + fontColor + ")"
        });

        if (name.length > 7) $("#patch-name").addClass("smaller-font");
        else $("#patch-name").removeClass("smaller-font");

        if (axis === "Vertical") {
            $("#patch-name").html(createVerticalText(name));
            // Center the Name
            $(".patch-preview #patch-name").width(28);
            patchNameX = position[0];
            patchNameY = centerY - ($patchName[0].getBoundingClientRect().height / 2);
        } else {
            $("#patch-name").html(name);
            patchNameX = centerX - ($patchName[0].offsetWidth / 2);
            patchNameY = position[1];
        }

        $patchName.css({
            top: patchNameY + "px",
            left: patchNameX + "px",
        }).delay(500).css("visibility", "visible");

    }

    function showLoadingGraphic() {
        var img = $('<img />', {
            src: M2.Util.config.pathToImages + "loading-bar.gif",
            alt: 'Loading'
        });
        img.addClass("loading");
        $(".patch-callout-content").addClass("hidden");
        $(".loading-area").html(img);
        $("#personalized-patch-container").css("overflow", "hidden");
    }

    const displayConfirmation = () => {
        // Show loading animation when submitted
        const $form = $("#config-patch-form");
        $form.submit(function (e) {
            showLoadingGraphic();
            if (isInIframe) resizePatchiFrame();
        });

        // Display Confirmation
        $(".patch-config").addClass("hidden");
        $(".patch-confirm").removeClass("hidden");

        $("#patch-configurator-copy").addClass("hidden");
        $("#patch-confirmation-copy").removeClass("hidden");

        // Scroll up (hey....)
        $("html, body").animate({ scrollTop: 0 }, "fast");
        if (isInIframe) {
            window.parent.$("html, body").animate({ scrollTop: 0 }, "fast");
            resizePatchiFrame();
        }
        // Display Shipping Address
        $(".recipient-address .first-name").html($("#FirstName").val());
        $(".recipient-address .last-name").html($("#LastName").val());
        $(".recipient-address .address1").html($("#AddressLine1").val());
        $(".recipient-address .address2").html($("#AddressLine2").val());
        $(".recipient-address .city").html($("#City").val());
        $(".recipient-address .state").html($("#State").val());
        $(".recipient-address .zip").html($("#Zip").val());
        $(".btn.confirm").addClass("hidden");
        $(".btn.submit").removeClass("hidden");
        $(".confirmation-cancel").removeClass("hidden");
        $(".btn.close-iframe-modal").addClass("hidden");
        $(".btn.previous-step").addClass("hidden");
        $(".give-patch-nav").addClass("center");
    }

    function personalizedPatchDialogSetup() {
        setCancelDialogs();
        if (M2.Util.exists($("select.name-on-patch"))) {

            var img = $('#patch-preview-image')
            if (img.prop('complete')) {
                setPatchNamePosition();
            } else {
                img.bind('load', function () {
                    window.setTimeout(function () {
                        setPatchNamePosition();
                    }, 200);
                });
            }

            // Live update Nickname Field
            $("#NickName").on('keyup keypress blur change', function (e) {
                const max = M2.PersonalizedPatch.config.nicknameCharacterCount;
                const currentCount = $(this).val().length;

                if (currentCount <= max) setPatchNamePosition();
                else {
                    e.preventDefault();
                    this.value = this.value.substring(0, max);
                }
            });

            // On Change for Name Drop Down
            $(document).on("change", ".name-on-patch", function (e) {
                e.preventDefault();
                setPatchNamePosition();

                // Show Nickname if selected
                if ($(this).val() === "NickName") {
                    $(".patch-options .field-grp.nick-name").hide();
                    $(".patch-options").addClass("show-nickname");
                    $(".patch-options .field-grp.nick-name").fadeIn();
                }
                else {
                    $(".patch-options").removeClass("show-nickname");
                    $(".patch-options .field-grp.nick-name").hide();
                }

                if ($(this).val() === "Initials") $("#patch-name").addClass("initials");
                else $("#patch-name").removeClass("initials");
            });
            // On Change Patch Style
            $(document).on("change", "#SelectedAvatarPersonalizedPatchId", function (e) {
                e.preventDefault();
                var onPatch = $(this).find("option:selected").val();

                var patchImageSelector = "#data-patch-image-" + onPatch;
                const patchImageSrc = $(patchImageSelector).data("patch-image");
                const $dataPatchSampleName = $("#data-patch-sample-name");
                $dataPatchSampleName.val(patchImageSrc);

                $("#patch-preview-image").attr("src", patchImageSrc);
            });

            // Submission Confirmation
            $(document).on("click", ".patch-callout-content .btn.confirm", function (e) {
                e.preventDefault();
                const $button = $(this);

                var $form = $("#config-patch-form");

                if ($form.valid()) {
                    disableSubmission($button);
                    const validationAddressUrl = $button.data("validate-address-url");
                    const token = $form.find("input[name='__RequestVerificationToken']").val();

                    // Validate Addresse First
                    const data = {
                        "": getAddressesForValidation(),
                        "__RequestVerificationToken": token,
                    }

                    postAddressForValidation(validationAddressUrl, data).done((addresses) => {
                        const invalidAddresses = [];
                        const validAddresses = [];
                        let hasPOBox = false;
                        addresses.forEach(function (address, i) {
                            const valid = address.valid;
                            const poBoxWarning = address.poBoxWarning;
                            address.index = i;

                            if (poBoxWarning) {
                                hasPOBox = true;
                            }
                            else if (valid) {
                                validAddresses.push(address);
                            } else {
                                invalidAddresses.push(address);
                            }
                        });

                        if (hasPOBox) {
                            M2.Modal.create("poBoxError", "Attention", "#pobox-alert", "modal-xs", true);
                            enableSubmission($button);
                        }
                        else if (invalidAddresses.length) {
                            showInvalidAddressWarning(invalidAddresses);
                            enableSubmission($button);
                        } else {
                            updateAddresses($(".shipping-address-container"), validAddresses, () => {
                                displayConfirmation();
                            });
                        }
                    });
                } else {
                    const $invalidFields = $(".address-fields .input-validation-error");
                    processHiddenErrors($invalidFields);
                }
            });

            // Cancel Confirmation Submission
            $(document).on("click", ".patch-callout-content .btn.confirmation-cancel", function (e) {
                e.preventDefault();
                // Hide Confirmation / Revert Form
                $(".patch-config").removeClass("hidden");
                $(".patch-confirm").addClass("hidden");

                $("#patch-configurator-copy").removeClass("hidden");
                $("#patch-confirmation-copy").addClass("hidden");
                $(".confirmation-cancel").addClass("hidden");

                const $submitBtn = $(".btn.confirm");
                $submitBtn.removeClass("hidden");
                enableSubmission($submitBtn)

                $(".btn.submit").addClass("hidden");
                $(".btn.close-iframe-modal").removeClass("hidden");
                $(".btn.previous-step").removeClass("hidden");
                $(".give-patch-nav").removeClass("center");

                // Scroll up (hey....)
                $("html, body").animate({ scrollTop: 0 }, "fast");
                if (isInIframe) {
                    window.parent.$("html, body").animate({ scrollTop: 0 }, "fast");
                    resizePatchiFrame();
                }
            });

        }
    }

    const disableSubmission = ($button) => {
        // Disable the buttons immediatly
        $button.addClass('disabled').attr('disabled', 'disabled');
    }
    const enableSubmission = ($button) => {
        // Re-enable the button as we've found suggestions
        $button.removeClass('disabled').removeAttr('disabled');
    }

    const setRoleSwitcher = () => {

        $(document).on("change", "#PersonalizedPatchTypeSearch", function (e) {
            e.preventDefault();
            const $patchSelector = $(this);
            const patchType = $patchSelector.val();
            const $filterContainer = $patchSelector.closest(".filter-table");
            $filterContainer.removeClass("filter-council filter-unit filter-group filter-participant");

            switch (patchType) {
                case "0":
                    $filterContainer.addClass("filter-council");
                    $("#UnitSearch").val("");
                    $("#GroupSearch").val("");
                    break;
                case "1":
                    $filterContainer.addClass("filter-unit");
                    break;
                case "2":
                    $filterContainer.addClass("filter-group");
                    break;
                case "3":
                    $filterContainer.addClass("filter-participant");
                    break;

            }
        });
    }

    const regenerationWarning = () => {
        $(document).on("click", ".regenerate-patch", function (e) {
            e.preventDefault();
            const $button = $(this);
            const modalTitle = $button.data("modal-title");
            const regenerateUrl = $button.attr("href");
            const $confirmButton = $("#regenerate-modal").find(".confirm-regenerate");
            $confirmButton.attr("href", regenerateUrl);
            M2.Util.closeActionMenu();
            M2.Modal.create("regenerate-patch", modalTitle, "#regenerate-modal", "modal-md", true);
        });
    }

    const setAddressSearch = () => {
        const ShippingAddressSearch = new AddressSearch(".address-autocomplete", {
            apiKey: "195948433105312307",
            lookupAddressUrl: "https://us-autocomplete-pro.api.smarty.com/lookup?",
            suggestionDelay: 300
        });

        ShippingAddressSearch.onOpen((searchInput) => {
            const $shippingAddressContainer = $(searchInput).closest(".shipping-address-container");
            $shippingAddressContainer.attr("data-view-mode", "searching");
            const $addressSuggestionRequired = $shippingAddressContainer.find(".address-search-required");
            $addressSuggestionRequired.val("False");
        });

        ShippingAddressSearch.onSelect((data, searchInput) => {
            const { address1, address2, city, state, zip } = data;
            const $shippingAddressContainer = $(searchInput).closest(".shipping-address-container");
            $shippingAddressContainer.attr("data-view-mode", "found");
            const $addressLine1 = $shippingAddressContainer.find(".address input[type='text']");
            const $addressLine2 = $shippingAddressContainer.find(".address2 input[type='text']");
            const $city = $shippingAddressContainer.find(".city input[type='text']");
            const $state = $shippingAddressContainer.find(".state select");
            const $zip = $shippingAddressContainer.find(".zip input[type='text']");

            $addressLine1.val(address1);
            $addressLine2.val(address2);
            $city.val(city);
            $state.val(state);
            $zip.val(zip);
        });

        $(document).on("click", ".find-another-address a", (e) => {
            e.preventDefault();
            const $shippingAddressContainer = $(e.currentTarget).closest(".shipping-address-container");
            clearFields($shippingAddressContainer);
            $shippingAddressContainer.attr("data-view-mode", "search");
            const $addressSuggestionRequired = $shippingAddressContainer.find(".address-search-required");
            $addressSuggestionRequired.val("True");
        });

        $(document).on("click", ".dont-see-address a", (e) => {
            e.preventDefault();
            const $shippingAddressContainer = $(e.currentTarget).closest(".shipping-address-container");
            clearFields($shippingAddressContainer);
            $shippingAddressContainer.attr("data-view-mode", "found");
            const $addressSuggestionRequired = $shippingAddressContainer.find(".address-search-required");
            $addressSuggestionRequired.val("False");
        });
    }

    const setValidateAddressTools = () => {
        const $invalidAddress = $("#InvalidAddress");
        $(document).on("click", ".confirm-unverified-address", function (e) {
            e.preventDefault();
            $invalidAddress.val("True");
            displayConfirmation();
            M2.Modal.close();
        });

        $(document).on("click", ".re-enter-address", function (e) {
            e.preventDefault();
            $invalidAddress.val("False");
            M2.Modal.close();
        });
    }

    M2.PersonalizedPatch = {
        config: {
            name: "M2 Personalized Patches",
            earnTypeTotalSales: "0",
            earnTypePerProduct: "1",
            nicknameCharacterCount: 10,
            patchNameLeftPosition: 26
        },
        init: function () {
            M2.PersonalizedPatch.criteriaTypeSelect();
            M2.PersonalizedPatch.givePatch();
            disablePatchRow();
            earnPatchToggle();
            setPatchGoalTypeSelector();
            personalizedPatchDialogSetup();
            setRecipientSelect();
            setRoleSwitcher();
            regenerationWarning();
            setAddressSearch();
            setValidateAddressTools();
        },
        // Called on Tab Change
        crossoverPatchesDataOnSuccess: function (result) {
            M2.PersonalizedPatch.givePatch();
            M2.Util.setSwitches();
            earnPatchToggle();
            regenerationWarning();
        },
        patchesDataOnSuccess: function (result) {
            M2.PersonalizedPatch.givePatch();
            M2.Util.setSwitches();
            regenerationWarning();
        },
        patchesEditOnSuccess: function (result) {
            $.validator.unobtrusive.parse($(".tabbed-content form#form0"));
            M2.Util.setSwitches();
            disablePatchRow();
            if ($("#Success").val() === "True") M2.Util.successMsg();
            else $("html, body").animate({ scrollTop: 0 }, "fast");

        },
        criteriaTypeSelect: function () {
            $(document).on("change", ".personalized-patches .criteria .criteria-type-select select", function () {
                const patchRef = $(this).closest("td");
                patchRef.find(".criteria-type input").val("");
                patchRef.find(".criteria-type").addClass("hidden");

                if ($(this).val() === M2.PersonalizedPatch.config.earnTypeTotalSales) patchRef.find(".criteria-total").removeClass("hidden");
                if ($(this).val() === M2.PersonalizedPatch.config.earnTypePerProduct) patchRef.find(".criteria-per-product").removeClass("hidden");
            });
        },
        givePatch: function () {
            earnerSearch();
            setPatchTypeSelect();
        },
        savePatchAddressOnSuccess: function (result) {
            const successFlag = $("#Success").val();
            personalizedPatchDialogSetup();
            if (successFlag !== "False") {
                M2.Util.successMsg();
            }
        },
        displayMessaging: function (method) {
            if (method === "cancel") $(".patch-callout-msg").removeClass("no-me2-success").addClass("cancel");
            if (method === "no-me2-save") $(".patch-callout-msg").removeClass("cancel").addClass("no-me2-success");
            if (isInIframe) resizePatchiFrame();
        }
    };
})(jQuery);

$(function () {
    M2.PersonalizedPatch.init();
});